import React from "react";
import { connect } from "react-redux";
import { ApplicationStore } from "src/store";
import { getVehicleThumbnail } from "src/store/selectors/vehicles";
import "./SidebarThumbnail.scss";

interface Props {
    vin: string;
}

const SidebarThumbnail = ({ thumbnail }: Props & ReturnType<typeof mapStateToProps>) => {
    return (
        <div className="SidebarThumbnail">
            <img className="SidebarThumbnail__image" src={thumbnail} alt="" />
        </div>
    );
};

const mapStateToProps = (state: ApplicationStore, { vin }: Props) => ({
    thumbnail: getVehicleThumbnail(state, vin),
});

export default connect(mapStateToProps)(SidebarThumbnail);
